<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>越南客户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
          <el-date-picker
          size="small"
        v-model="date"
          unlink-panels
      type="daterange"
      ormat="yyyy 年 MM 月 dd 日"
      value-format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
        <!-- <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input> -->
      </el-form-item>
        <el-form-item  label="性别:">
            <el-select v-model="value"  style="width:150px"  size="small" placeholder="请选择性别">
                <el-option label="男" value="shanghai"></el-option>
                <el-option label="女" value="beijing"></el-option>
        </el-select>
       </el-form-item>

      <el-form-item label="年龄范围:">
        <div class="flexc-cen-x">
            <el-input size="small"  v-model="formInline.deptNo" placeholder="输入起始年龄"  style="width:150px"></el-input> 
            <div style="margin-left:10px;margin-right:10px">~</div>
            <el-input size="small" v-model="formInline.deptNo" placeholder="输入结束年龄"  style="width:150px"></el-input>
        </div>
      </el-form-item>
       <el-form-item  label="行业:" >
            <el-select v-model="value"  style="width:150px" size="small" placeholder="请选择行业">
                <el-option label="金融" value="shanghai"></el-option>
                <el-option label="其他" value="beijing"></el-option>
        </el-select>
       </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="danger" icon="el-icon-plus" @click="handleEdit()">购买</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="tableData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
  
      <el-table-column sortable prop="Line1" label="序号" width="100">
      </el-table-column>
    <el-table-column sortable prop="phone" label="手机" >
      </el-table-column>
      <el-table-column sortable prop="name" label="姓名" >
      </el-table-column>
      <el-table-column sortable prop="facebook" label="facebook" >
      </el-table-column>
       <el-table-column sortable prop="whatsapp" label="whatsapp" >
      </el-table-column>
      <el-table-column sortable prop="addtime" label="时间" >
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog">
      
      <el-form label-width="120px" :model="editForm"  ref="editForm">
         <el-form-item label="总条数:" prop="deptName">
            <div style="font-size:20px;font-weight:700">{{buyList.allcount}}</div>
        </el-form-item>
          <el-form-item label="购买费用:" prop="deptName">
            <div style="font-size:20px;font-weight:700;color:red">￥{{buyList.allMoney}}</div>
        </el-form-item>
        <el-form-item label="当前余额:" prop="deptName">
            <div style="font-size:20px;font-weight:700;color:red">￥{{buyList.money}}</div>
        </el-form-item>
        <el-form-item label="备注：" prop="deptNo">
          <el-input size="small" v-model="info" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm()">立即下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getListCustomerYN,getBuyInfo,addShopBuyInfo} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      value12:'',
      value:'',
      date:[],
      value1:"",
      stime:'',
      etime:'',
      buyList:[],
       info:'',
      tableData:[],
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        // token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入商户名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        deptNo: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        deptNo: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        deptNo: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      
    WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total:0,
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    // this.getdata(this.formInline)
    this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  async  getList(){
     this.tableLoading = true
    const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // setTimeout(() => {
        //   loading.close();
        // }, 2000);

    const crs = await getListCustomerYN({
  
      token:localStorage.getItem('token'),
      stime:this.date[0],
      etime:this.date[1],
      pages:this.formInline.page,
      psize:this.formInline.limit
      // this.pageparm.currentPage = this.formInline.page
      // this.pageparm.pageSize = this.formInline.limit
      // this.pageparm.total = res.count
          // selectName:this.selectName,
          // pages:this.pages,//第几页
          // psize:this.psize//一页几条
        })
        if(crs.orsuccess=='1'){
          this.tableLoading = false
          this.pageparm.total = crs.allcount
                 var list = crs.data
          list.forEach(items => {
            items.addtime = items.addtime.slice(0,10)
            items.addtime = items.addtime.replace(/\//g, '-')
          //   items.addtime =  items.addtime.splice(0.6)
          });
          this.tableData = crs.data
           loading.close();
        }else{
          this.tableLoading = false
           loading.close();
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      if(this.date){

      } else {
        this.date = []
      }
      console.log(this.date)
      this.getList()
      // this.getdata(this.formInline)
    },
   async  getBuyInfo(){
      const crs = await getBuyInfo({
      LoginID:localStorage.getItem('ID'),
      token:localStorage.getItem('token'),
      stime:this.date[0],
      etime:this.date[1],
      gmType:2
      // this.pageparm.currentPage = this.formInline.page
      // this.pageparm.pageSize = this.formInline.limit
      // this.pageparm.total = res.count
          // selectName:this.selectName,
          // pages:this.pages,//第几页
          // psize:this.psize//一页几条
        })
        if(crs.orsuccess=='1'){
          this.editFormVisible = true
        this.title = '购买'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
          // this.tableLoading = false
          // this.pageparm.total = crs.allcount
          this.buyList = crs
          //  loading.close();
        }else{
          // this.tableLoading = false
          //  loading.close();
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
    //显示编辑界面
    handleEdit: function(index, row) {
        this.getBuyInfo()
      
     
    },
    // 编辑、增加页面保存方法
    async  submitForm() {
    const loading = this.$loading({
          lock: true,
          text: '下载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
    const crs = await addShopBuyInfo({
      token:localStorage.getItem('token'),
      LoginID:localStorage.getItem('ID'),
      stime:this.date[0],
      etime:this.date[1],
      gmType:2,
      hy:"",
      sex:"",
      age:'',
      info:this.info
    })
        if(crs.orsuccess=='1'){
          this.editFormVisible = false
          window.open(crs.xlsFile)
            this.$message({
                  type: 'success',
                  message: '下载成功'
                })
          // this.tableLoading = false
          // this.pageparm.total = crs.allcount
          // this.tableData = crs.data
           loading.close();
        }else{
          // this.tableLoading = false
           loading.close();
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }

      // this.$refs[editData].validate(valid => {
      //   if (valid) {
      //     deptSave(this.editForm)
      //       .then(res => {
      //         this.editFormVisible = false
      //         this.loading = false
      //         if (res.success) {
      //           this.getdata(this.formInline)
      //           this.$message({
      //             type: 'success',
      //             message: '公司保存成功！'
      //           })
      //         } else {
      //           this.$message({
      //             type: 'info',
      //             message: res.msg
      //           })
      //         }
      //       })
      //       .catch(err => {
      //         this.editFormVisible = false
      //         this.loading = false
      //         this.$message.error('公司保存失败，请稍后再试！')
      //       })
      //   } else {
      //     return false
      //   }
      // })
    
    
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}


</style>



// WEBPACK FOOTER //
// src/views/Vietnam/Vietnam.vue